import { AgTechGridControlProps } from "../Data/AgTechGridProps";
import { useState, useEffect, useRef } from "react";

export const AgTechGridTextControl = (props: React.PropsWithChildren<AgTechGridControlProps<string>>) => {
    let [controlValue, setControlValue] = useState(props.value);
    let lastValue = useRef(props.value);

    useEffect(() => {
        if (props.value !== controlValue) {
            setControlValue(props.value);
            lastValue.current = props.value;
        }
    }, [props.value]);

    return (
        <div className="stretched p-0 border-0 bg-transparent outline-none max-w-[100%] flex">
            <input
                className="stretched py-1 px-3 text-sm bg-transparent outline-none focus:border flex"
                value={controlValue}
                readOnly={props.readonly}
                onChange={e => setControlValue(e.currentTarget.value) }
                onFocus={e => e.stopPropagation()}
                onKeyDown={e => {
                    if (e.key === 'Enter' && props.onUpdated && (controlValue !== lastValue.current)) {
                        lastValue.current = controlValue;
                        props.onUpdated(controlValue);
                    }
                }}
                onBlur={e => {
                    if (props.onUpdated && (controlValue !== lastValue.current)) {
                        lastValue.current = controlValue;
                        props.onUpdated(controlValue);
                    } 
                }}
                tabIndex={props.readonly ? -1 : 0}
            />
        </div>
    )
}